module.exports = __webpack_public_path__ + "img/up-arrow-white.bb5e187f.svg";